// extracted by mini-css-extract-plugin
export default {"root":"M_dBmKw1","header":"ecVKX-Gc","title":"_3Iay4TaO","content":"_2dWVLgCM","body":"SVvQ5mqd","footer":"_1vvKkZTI","headerAfter":"_1jEt7c0x","headerBefore":"_1e0H5tEg"};